// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"a58cae59","423":"640e4e21","473":"ad0050ee"}[chunkId] + ".chunk.css";
};